import { Button, ButtonProps, SimpleText } from 'platform-components/common';
import React from 'react';

interface Props extends ButtonProps {
    textId: string;
    mix?: string;
}

export const SpecCourseLessonViewStubButton = React.memo(({ textId, mix, ...props }: Props) => {
    return (
        <Button
            className={mix}
            transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
            view={Button.VIEW.SECONDARY}
            {...props}
        >
            <SimpleText id={textId} />
        </Button>
    );
});
